import { createStore } from 'satcheljs';
import type { ModuleContextMailboxInfoData } from './schema/ModuleContextMailboxInfoData';

export const defaultStore: ModuleContextMailboxInfoData = {
    moduleContextMailboxInfo: undefined,
};

const getModuleContextMailboxInfoStore = createStore<ModuleContextMailboxInfoData>(
    'ModuleContextMailboxInfoData',
    defaultStore
);
export default getModuleContextMailboxInfoStore;
